/* NX1 PROJECT | Glaze | interactive sections. No dependencies. */
(function () {
  'use strict';

  function initSlider(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var track = root.querySelector('[data-nx-track]');
    var fill = root.querySelector('[data-nx-fill]');
    var prev = root.querySelector('[data-nx-prev]');
    var next = root.querySelector('[data-nx-next]');
    if (!track) return;
    function step() { var first = track.children[0]; return first ? first.getBoundingClientRect().width + 16 : track.clientWidth; }
    function update() {
      if (!fill) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      var w = Math.max(ratio * 100, 12);
      var pos = max > 0 ? (track.scrollLeft / max) * (100 - w) : 0;
      fill.style.width = w + '%'; fill.style.left = pos + '%';
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initTabs(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var tabs = root.querySelectorAll('[data-nx-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-nx-tab');
        root.querySelectorAll('[data-nx-tab]').forEach(function (t) { var on = t.getAttribute('data-nx-tab') === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        root.querySelectorAll('[data-nx-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-nx-panel') === id); });
      });
    });
  }

  function initCompare(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var range = root.querySelector('input[type=range]');
    if (!range) return;
    function set() { root.style.setProperty('--nx-pos', range.value + '%'); }
    range.addEventListener('input', set); set();
  }

  function initVideos(root) {
    if (root.dataset.nxReady) return; root.dataset.nxReady = '1';
    var cards = root.querySelectorAll('.nx-vcard');
    function activate(card) {
      cards.forEach(function (c) {
        if (c !== card) { c.classList.remove('is-active', 'is-playing'); var v = c.querySelector('video'); if (v) { v.pause(); } }
      });
      card.classList.add('is-active');
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var video = card.querySelector('video');
        if (!card.classList.contains('is-active')) { activate(card); card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); return; }
        if (video) {
          if (video.paused) { video.muted = false; video.play(); card.classList.add('is-playing'); }
          else { video.pause(); card.classList.remove('is-playing'); }
        }
      });
    });
  }

function initVideos(root) {
  if (root.dataset.nxReady) return;
  root.dataset.nxReady = '1';

  var cards = Array.from(root.querySelectorAll('.nx-vcard'));
  var isDragging = false;
  var startX = 0;
  var scrollLeft = 0;
  var dragDistance = 0;

  function activate(card) {
    cards.forEach(function (c) {
      if (c !== card) {
        c.classList.remove('is-active', 'is-playing');

        var video = c.querySelector('video');
        if (video) video.pause();
      }
    });

    card.classList.add('is-active');
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (event) {
      if (dragDistance > 5) {
        event.preventDefault();
        event.stopPropagation();
        dragDistance = 0;
        return;
      }

      if (!card.classList.contains('is-active')) {
        activate(card);
        card.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
        return;
      }

      var video = card.querySelector('video');

      if (video) {
        if (video.paused) {
          video.muted = false;
          video.play();
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      }
    });
  });

  root.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    isDragging = true;
    startX = event.clientX;
    scrollLeft = root.scrollLeft;
    dragDistance = 0;

    root.classList.add('is-dragging');
  });

  root.addEventListener('pointermove', function (event) {
    if (!isDragging) return;

    var distance = event.clientX - startX;
    dragDistance = Math.max(dragDistance, Math.abs(distance));

    if (dragDistance > 5) {
      root.scrollLeft = scrollLeft - distance;
    }
  });

  function stopDragging() {
    if (!isDragging) return;

    isDragging = false;
    root.classList.remove('is-dragging');

    setTimeout(function () {
      dragDistance = 0;
    }, 50);
  }

  root.addEventListener('pointerup', stopDragging);
  root.addEventListener('pointercancel', stopDragging);
  root.addEventListener('pointerleave', function (event) {
    if (event.pointerType === 'mouse') stopDragging();
  });
}

    function init(scope) {
      var s = scope || document;

      s.querySelectorAll('[data-nx-slider]').forEach(initSlider);
      s.querySelectorAll('[data-nx-tabs]').forEach(initTabs);
      s.querySelectorAll('[data-nx-compare]').forEach(initCompare);
      s.querySelectorAll('[data-nx-videos]').forEach(initVideos);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });


  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();